<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..."
  type="ball-scale-multiple">
</ngx-spinner>
<section class="header_container">
  <div class="row no-margin">
    <div class="col-md-2">
      <div class="logo_container ">
        <div class="inner_logo"></div>
      </div>
    </div>
    <div class="col-md-2">
      <div class="dropdown" style="margin-top: 20%; text-align: center" [hidden]="displayRoleDropdownFlag">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          Select Roles
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a *ngFor="let item of dropdownValues" (click)="roleChange($event)" class="dropdown-item">{{item}}</a>
        </div>
      </div>
    </div>
    <div class="col-md-3 mt-5">
      <span style="font-weight: bold;" *ngIf="checkOperationType"> Operation Type: </span>
      <span style="color: blue; font-weight: bold" *ngIf="checkOperationType">{{this.userOperationType | translate}}</span>
    </div>
    <div class="col-md-3 ">
      <div class="menu_wrapper">
        <ul class="menu">
          <li *ngIf="firstTime != true && disableMenu != true">
            <a href="#" routerLink="/dashboard">
              <i class="fa fa-home fa-2x" pTooltip="{{'HOME' | translate}}" tooltipPosition="top"></i>
            </a>
          </li>

          <li class="register_link" *ngIf="adminAccess == 5 || adminAccess == 8 || adminAccess == 9">
            <a href="#" routerLink="/um">
              <i class="fa fa-users fa-2x" pTooltip="{{'USERMANAGEMENT' | translate}}" tooltipPosition="top"></i>
            </a>
          </li>
          <li class="register_link" *ngIf="adminAccess == 5 || adminAccess == 8 || adminAccess == 9">
            <a href="#" routerLink="/register">
              <i class="fa fa-user-plus fa-2x" pTooltip="{{'REGISTER' | translate}}" tooltipPosition="top"></i>
            </a>
          </li>
          <li class="maintainence_link" *ngIf="adminAccess == 5">
            <a href="#" routerLink="/Maintainence-Activity">
              <!-- <img
                src="../../../assets/calendar-icon.svg"
                style="width: 1.2rem; height: 1rem; cursor: pointer;"
              /> -->
              <i class="fa fa-calendar fa-2x" pTooltip="{{'PlannedMaintenance' | translate}}" tooltipPosition="top"></i>
            </a>
          </li>
        </ul>
        <!-- end .menu -->
      </div>
    </div>
    <div class="col-md-2 user_profile">
      <ul class="nav navbar-nav ml-auto float-right">
        <li class="nav-item dropdown user_profile_nav">
          <div class="row">
            <div class="col-md-8 no-pad text-right">
              <div class="pad-top-15">{{ "WELCOME" | translate }}</div>
              <div class="d-md-down-none" id="username">{{ loggedInUser }}</div>
              <div class="d-md-down-none adminrole" id="userrole">
                ({{ adminRole }})
              </div>
            </div>
            <div class="col-md-4 no-pad">
              <a class="nav-link dropdown-toggle nav-link" data-toggle="dropdown" href="#" role="button"
                aria-haspopup="true" aria-expanded="false">
                <img src="../../../assets/profile-icon.png" class="img-avatar" alt="" />
              </a>
              <ul class="dropdown-menu dropdown-menu-right">
                <!--<li class="dropdown-item" id="resetPassword">
                  <a href="#" routerLink="/resetPassword">
                    <i class="fa fa-life-ring"></i>
                    {{ "RESET_PWD" | translate }}</a>
                </li>-->
                <li class="dropdown-item" (click)="switchLanguage('en')" id="en">
                  <img src="../../../assets/us.png" id="en-img" /> {{ "ENGLISH" | translate }}
                </li>
                <li class="dropdown-item" (click)="switchLanguage('jn')" id="jn">
                  <img src="../../../assets/Jap-Flag.png" id="jn-img" /> {{ "JAPANESE" | translate }}
                </li>
                <li class="dropdown-item" (click)="authSignOut()" id="logout">
                  <i class="fa fa-lock"></i> {{ "LOGOUT" | translate }}
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</section>